import { Component, AfterContentInit, Input } from '@angular/core';

import { PlycaDataService } from '../../services/plyca.service';
import { PaginationInfo, PaginationDTO } from '../api/PaginationModel';
import { AuditTaskDTO, Link } from '../api/plyca-dtos';
import { UserService } from '../user.service';
import { ServiceLocator } from '../ServiceLocator';
import { Configuration } from '../conf/app.constants';
import { BaseComponent } from '../components/common/baseComponent/base.component';

declare var jQuery: any;

@Component({
  selector: 'audituser',
  templateUrl: 'audit.user.template.html'
})
export class auditUserComponent extends BaseComponent implements AfterContentInit {
  @Input() layoutClass: string;
  @Input() title: string;
  @Input() titleKey: string;
  @Input() description: string;
  @Input() descriptionKey: string;
  loaded: boolean = false;
  auditUserList: AuditTaskDTO[];
  pagInfo: PaginationInfo;
  pagLinks: Link[];


  userColor: string;
  userLetters: string;

  public expanded = false;


  constructor(public plycaService: PlycaDataService,
    private configuration: Configuration,
    private userService: UserService) {
    super();

    this.userColor = this.userService.getUserColor();
    this.userLetters = this.userService.getUserLetters();
    if (jQuery(document).width() < 769) {
      this.expanded = false;
    }
  }

  ngAfterContentInit(): void {

    this.loaded = false;
    this.load();
  }
  public isLoaded(): boolean {
    return this.loaded;
  }

  load() {

    this.subscribe(this.plycaService
      .query<AuditTaskDTO>(
        this.configuration.USERS_SERVICE_URL + this.userService.getUserId() +
        '/auditTasks?expand=expansionSet:WEBCLIENT_WIDGET',
        this.getParams()),
      (param: PaginationDTO<AuditTaskDTO>) => {


        if (param && param.content) {
          this.auditUserList = param.content;
          this.pagInfo = param.page;
        } else {
          this.auditUserList = [];
        }

        this.loaded = true;
      });
  }






  getParams() {
    return {
      // expand: 'expansionSet:...',
      page: '0',
      size: '10'
      //,      type: 'RUNNING'
    }
  }
}
